import { FC, useContext, useEffect, useState } from 'react';
import { ThemeContext } from 'styled-components';
import { ThemeEnum } from '../../handlers/ThemeHandler';
import footerImage from './../../assets/footer.png';
import darkfooterImage from './../../assets/footer-dark.png';

import * as S from './styles';

export const Footer: FC = () => {
  const [eventRightPos, setEventRightPos] = useState(16.7);
  const theme = (useContext(ThemeContext) as any).theme || ThemeEnum.light;

  useEffect(() => {
    const timer = setInterval(() => {
      setEventRightPos(oldPos => {
        return oldPos >= 64.9 ? 16.7 : oldPos + 0.01;
      });
    }, 10);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <S.Footer>
      <img
        src={theme === ThemeEnum.light ? footerImage : darkfooterImage}
        alt="footer"
      />
      <S.Event style={{ right: `${eventRightPos}%` }} />
      <S.Event style={{ right: `${eventRightPos + 1}%` }} />
    </S.Footer>
  );
};
